import Section from 'layouts/Section/Section';

import CollapseSection from 'components/CollapseSection/CollapseSection';
import Title from 'components/Title/Title';

import items from './items';

const CookiePolicy = () => {
  return (
    <Section>
      <Title title="Cookie Policy" textAlign="left"></Title>
      {items.map(({ title, summary, details }, index) => (
        <CollapseSection
          title={title}
          summary={summary}
          details={details}
          index={index}
        />
      ))}
    </Section>
  );
};

export default CookiePolicy;
